// utils
import axios from "src/utils/axios";
import apiSlice from "src/utils/api-slice";
import { setURLParams } from "src/utils/url-query";

// ----------------------------------------------------------------------

const API_ENDPOINTS = {
    createDraft: `/shipment/create_draft`,
    editDraft: `/shipment/edit_draft`,
    cancelDraft: "/shipment/delete_draft",
    // getDraftDetail: `/shipment/draft/detail`,
    //
    getShipmentDraft: "/shipment/search_draft",
    getShipment: "/shipment/search_shipped",
    getRate: `/shipment/get_latest_rates_v2`,
    buyLabel: "/shipment/buy_label",
    downloadLabel: "/shipment/download_label",
    voidLabel: "/shipment/void_label",
    getShipmentDetail: "/shipment/query_shipped_detail",
    getImportShipmentPreSignedURL: "/shipment/shipment_import_pre_signed_url",
    importShipments: "/shipment/import_shipments",
    queryTaskResult: "/task_manager/batch_query_by_ids",





    getShipmentDetailByTracking: "/shipment/detail/get_by_tracking_no",
    getShipmentOperateHistory: `/shipment/get_operate_history`,
    //
    getShipmentMapURL: `/shipment/maps/get_url`,
    //
    getExchangeRate: `/shipment/exchange/rate`,
    getInsuranceRate: "/shipment/insurance/rate",
    //
    //
    checkCanPrint: `/shipment/can_print_label`,
    //
    qrcodePreview: "/shipment/preview_qr_or_barcode",
    //
    createShareLink: "/shipment/create_share_link",
    previewShareLink: "/shipment/preview_share_link",
    //
    initExportShipment: `/shipment/export`,
    //
    getDistinctProviderId: `/shipment/distinct_provider_id`
};

// ----------------------------------------------------------------------
const getImportShipmentPreSignedURL = () => axios.get(`${ API_ENDPOINTS.getImportShipmentPreSignedURL }`);
const importShipments = (request) => axios.post(`${ API_ENDPOINTS.importShipments }`, { ...request });

const getShipmentDetail = (id) => axios.get(`${ API_ENDPOINTS.getShipmentDetail }`, {
    params: {
        shipment_id: id
    }
});

const getShipmentDetailByTracking = (number) => axios.get(`${ API_ENDPOINTS.getShipmentDetailByTracking }`, {
    params: {
        tracking_no: number
    }
});

const getShipmentOperateHistory = (id) => axios.get(`${ API_ENDPOINTS.getShipmentOperateHistory }`, {
    params: {
        shipment_no: id
    }
});

const getShipmentMapURL = (request) => axios.get(`${ API_ENDPOINTS.getShipmentMapURL }`, {
    params: {
        ...request
    }
});

const getRate = (request) => axios.get(`${ API_ENDPOINTS.getRate }`, { params: { ...request } });

const getExchangeRate = (request) => axios.get(`${ API_ENDPOINTS.getExchangeRate }`, {
    params: {
        ...request
    }
});

const getInsuranceRate = (request) => (signal) => axios.get(`${ API_ENDPOINTS.getInsuranceRate }`, {
    params: {
        ...request
    },
    signal // 传递 AbortSignal
});

const createDraft = (request) => axios.post(`${ API_ENDPOINTS.createDraft }`, { ...request });

const editDraft = (request) => axios.post(`${ API_ENDPOINTS.editDraft }`, { ...request });

const buyLabel = (request) => axios.post(`${ API_ENDPOINTS.buyLabel }`, { ...request });

const voidLabel = (request) => axios.post(`${ API_ENDPOINTS.voidLabel }`, {...request});

const cancelDraft = (request) => axios.post(`${ API_ENDPOINTS.cancelDraft }`, { ...request });

const downloadLabel = (request, config) => axios.get(`${ API_ENDPOINTS.downloadLabel }`, { 
    params: { ...request },
    ...config
});

const checkCanPrint = () => axios.get(`${ API_ENDPOINTS.checkCanPrint }`);

// const previewLabel = (request, config) => axios.post(`${ API_ENDPOINTS.labelPreview }`, { ...request }, { responseType: "blob", ...config });

const previewQRCode = (id, config) => axios.get(`${ API_ENDPOINTS.qrcodePreview }`, {
    params: {
        shipment_no: id
    },
    responseType: "blob",
    ...config
});

const createShareLink = (id) => axios.get(`${ API_ENDPOINTS.createShareLink }`, {
    params: {
        shipment_no: id
    }
});

const previewShareLink = (request) => axios.post(`${ API_ENDPOINTS.previewShareLink }`, { ...request }, { responseType: "blob" });

const initExportShipment = (request) => axios.get(`${ API_ENDPOINTS.initExportShipment }`, {
    params: {
        ...request
    }
});

const queryTaskResult = (config) => axios.get(`${ API_ENDPOINTS.queryTaskResult }`, { ...config });

// ----------------------------------------------------------------------

const {
    useGetShipmentDraftListQuery,
    useGetShipmentListQuery,
    useGetDistinctProviderIdQuery,
    //
    useCancelDraftMutation,
    // useGetDraftDetailQuery
} = apiSlice.injectEndpoints({
    endpoints: builder => ( {
        getShipmentDraftList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "ShipmentDraftList" ],
            query: (request) => `${ API_ENDPOINTS.getShipmentDraft }${ setURLParams(request) }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        getShipmentList: builder.query({
            keepUnusedDataFor: 5,
            providesTags: [ "ShipmentList" ],
            query: (request) => `${ API_ENDPOINTS.getShipment }${ setURLParams(request) }`,
            transformResponse: ({ data }, meta, arg) => data
        }),
        getDistinctProviderId: builder.query({
            keepUnusedDataFor: 60,
            query: () => API_ENDPOINTS.getDistinctProviderId,
            transformResponse: ({ data }, meta, arg) => data
        }),
        //
        cancelDraft: builder.mutation({
            query: (request) => ( {
                url: `${ API_ENDPOINTS.cancelDraft }${ setURLParams(request) }`,
                method: "GET"
            } ),
            invalidatesTags: [ "ShipmentDraftList" ]
        }),
        // getDraftDetail: builder.query({
        //     providesTags: [ "DraftShipment" ],
        //     query: () => `${ API_ENDPOINTS.getDraftDetail }`,
        //     transformResponse: ({ data }, meta, arg) => data
        // })
    } ),
    overrideExisting: true
});

// ----------------------------------------------------------------------

export {
    useGetShipmentDraftListQuery,
    useGetShipmentListQuery,
    useGetDistinctProviderIdQuery,
    //
    useCancelDraftMutation,
    // useGetDraftDetailQuery,
    //
    getShipmentDetail as getShipmentDetailAPI,
    getShipmentDetailByTracking as getShipmentDetailByTrackingAPI,
    getShipmentOperateHistory as getShipmentOperateHistoryAPI,
    //
    getShipmentMapURL as getShipmentMapURLAPI,
    getImportShipmentPreSignedURL as getImportShipmentPreSignedURLAPI,
    importShipments as importShipmentsAPI,
    queryTaskResult as queryTaskResultAPI,
    //
    getRate as getRateAPI,
    getExchangeRate as getExchangeRateAPI,
    getInsuranceRate as getInsuranceRateAPI,
    //
    createDraft as createDraftAPI,
    editDraft as editDraftAPI,
    cancelDraft as cancelDraftAPI,
    //
    buyLabel as buyLabelShipmentAPI,
    voidLabel as voidLabelAPI,
    downloadLabel as downloadLabelAPI,
    //
    checkCanPrint as checkCanPrintAPI,
    //
    // previewLabel as previewLabelAPI,
    previewQRCode as previewQRCodeAPI,
    //
    createShareLink as createShareLinkAPI,
    previewShareLink as previewShareLinkAPI,
    //
    initExportShipment as initExportShipmentAPI
};
